"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ecom = void 0;
var Agent_1 = require("./agent/implementation/Agent");
var GetContentMenusUseCase_1 = require("./sections/content/useCases/getContentMenus/GetContentMenusUseCase");
var GetContentHomeUseCase_1 = require("./sections/content/useCases/getContentHome/GetContentHomeUseCase");
var GetContentPageUseCase_1 = require("./sections/content/useCases/getContentPage/GetContentPageUseCase");
var GetContentPageByIdUseCase_1 = require("./sections/content/useCases/GetContentPageByIdUseCase/GetContentPageByIdUseCase");
var GetUserUseCase_1 = require("./sections/users/useCases/getUser/GetUserUseCase");
var RequestPasswordUseCase_1 = require("./sections/users/useCases/requestPassword/RequestPasswordUseCase");
var SignInUseCase_1 = require("./sections/users/useCases/signIn/SignInUseCase");
var SignUpUseCase_1 = require("./sections/users/useCases/signUp/SignUpUseCase");
var UpdateUserUseCase_1 = require("./sections/users/useCases/updateUser/UpdateUserUseCase");
var GetConfigsUseCase_1 = require("./sections/configs/useCases/getConfigs/GetConfigsUseCase");
var Ecom = /** @class */ (function () {
    function Ecom(configProps) {
        this.authToken = '';
        this.sessionToken = '';
        this.userLocale = '';
        this.forwardedHost = '';
        this.forwardedFor = '';
        this.origin = '';
        this.cancelToken = '';
        this.configProps = configProps;
        this.agent = this.configureAgent(this.getConfigPropsm(), configProps.headers || {});
    }
    Object.defineProperty(Ecom.prototype, "transport", {
        get: function () {
            return this.agent.transport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "content", {
        get: function () {
            return {
                getContentMenus: new GetContentMenusUseCase_1.GetContentMenusUseCase(this.agent),
                getContentHome: new GetContentHomeUseCase_1.GetContentHomeUseCase(this.agent),
                getContentPage: new GetContentPageUseCase_1.GetContentPageUseCase(this.agent),
                getContentPageById: new GetContentPageByIdUseCase_1.GetContentPageByIdUseCase(this.agent)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "user", {
        get: function () {
            return {
                getUser: new GetUserUseCase_1.GetUserUseCase(this.agent),
                requestPassword: new RequestPasswordUseCase_1.RequestPasswordUseCase(this.agent),
                signIn: new SignInUseCase_1.SignInUseCase(this.agent),
                signUp: new SignUpUseCase_1.SignUpUseCase(this.agent),
                updateUser: new UpdateUserUseCase_1.UpdateUserUseCase(this.agent),
                setUserAvatar: new UpdateUserUseCase_1.UpdateUserUseCase(this.agent)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "configs", {
        get: function () {
            return {
                getConfigs: new GetConfigsUseCase_1.GetConfigsUseCase(this.agent),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "headers", {
        set: function (userHeaders) {
            this.authToken = userHeaders.authToken;
            this.sessionToken = userHeaders.sessionToken;
            this.userLocale = userHeaders.userLocale;
            this.forwardedHost = userHeaders.forwardedHost;
            this.forwardedFor = userHeaders.forwardedFor;
            this.origin = userHeaders.origin;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "setConfigs", {
        set: function (userConfigs) {
            this.cancelToken = userConfigs.cancelToken;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "auth", {
        set: function (tokens) {
            this.authToken = tokens.authToken;
            this.sessionToken = tokens.sessionToken;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "locale", {
        set: function (locale) {
            this.userLocale = locale;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Ecom.prototype.setLocale = function (locale) {
        this.userLocale = locale;
        this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
    };
    Ecom.prototype.getHeaders = function () {
        var headers = {};
        if (this.authToken) {
            headers['Authorization'] = "Bearer ".concat(this.authToken);
        }
        if (this.sessionToken) {
            headers['x-session-token'] = this.sessionToken;
        }
        if (this.userLocale) {
            headers['x-user-locale'] = this.userLocale;
        }
        if (this.forwardedHost) {
            headers['x-forwarded-host'] = this.forwardedHost;
        }
        if (this.forwardedFor) {
            headers['x-forwarded-for'] = this.forwardedFor;
        }
        if (this.origin) {
            headers['origin'] = this.origin;
        }
        return headers;
    };
    Ecom.prototype.getConfigPropsm = function () {
        var config = __assign({}, this.configProps);
        if (this.cancelToken) {
            config['cancelToken'] = this.cancelToken;
        }
        return config;
    };
    Ecom.prototype.configureAgent = function (configProps, headers) {
        return new Agent_1.Agent(configProps.baseUrl, headers, configProps);
    };
    return Ecom;
}());
exports.Ecom = Ecom;
//# sourceMappingURL=Ecom.js.map